<template>
  <div class="wcm-order-container">
    <!--    普客打包-->
    <div class="container h-100" style="background-color: #fff">
      <div class="content">
        <div class="header">
          <search-form ref="search" :query-params.sync="searchCondition" class="search-form" :can-export="false"
                       :fix-more-query="true" :show-order-way="false" :configs="MapSearchConfigs" default-time-query
                       @handleQuery="onSubmit">
            <div style="float:right;margin-bottom: 10px;display: flex;">
              <export-btn size="mini" :can-export="userAuth.can_export_adv_order_puke" btn-type="warning"
                          @export="handleExport('refExportBtn')" ref="refExportBtn" :lint-title="`导出`"
                          style="margin-right:10px;"/>
              <el-button @click="handleAdd('create')" class="d-flex-row funcbars-button el-button--operation"
                         v-if="userAuth.can_create_adv_order_puke" size="mini">
                <i class="el-icon-plus"></i>新增项目
              </el-button>
              <el-button @click="handleAdd('discount')" class="d-flex-row funcbars-button"
                         v-show="userAuth.rebate_config_info" size="mini" style="margin-right: 10px">
                {{ userAuth.rebate_config_save ? '设置' : '查看' }}折扣选项
              </el-button>
            </div>
          </search-form>
        </div>

        <!--    广告订单列表表格  -->
        <div class="tableCon default-table">
          <el-table :data="dataList"
                    ref="table"
                    v-loading="loading"
                    :expand-row-keys="expandKeys"
                    :row-key="`id`"
                    highlight-current-row border>
            <el-table-column type="selection" width="55" fixed="left"/>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <ChildOrderTable :pid="scope.row.id" :key="`child-table-${key}`" :pt="pt" :is-pre-executor="isPreExecutor"/>
              </template>
            </el-table-column>
            <el-table-column key="操作项" label="操作项" header-align="center" align="center" class-name="handle-row"
                             width="140">
              <template slot-scope="{row,$index}">
                <div class="buttons d-flex-row align-items-center">
                  <el-button size="mini" type="text" icon="el-icon-plus" @click="handleCommand('child',row)"
                             :disabled="!(userAuth.can_create_adv_order)">添加子单
                  </el-button>
                </div>
                <AdOptColumn :pt="pt" :row="row" :row-index="$index" :onlyMore="true" editRouteName="editAdOrderRegulars"
                             @refreshOrderList="afterDeal"/>
              </template>
            </el-table-column>
            <el-table-column label="订单编号" prop="order_no" width="160" align="center">
              <template slot-scope="{row}">
                <el-link type="primary" @click="goOrderDetail(row)" :title="`${row.customer_name||''}`">
                  {{ row.order_no }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column label="乙方名称" prop="company_name" width="100" align="center"></el-table-column>
            <el-table-column label="客户名称" prop="customer_name" width="200" align="center" show-overflow-tooltip>
              <template slot-scope="{row}">
                <el-link type="primary" @click="goOrderDetail(row)">
              <span style="padding: 1px 1px; background-color: #FF5722; color: #fff; font-size: 12px;"
                    v-show="row.order_type === 'strike' || row.order_type === '冲账类型'"
              >冲</span>
                  {{ row.customer_name || '-' }}
                </el-link>
              </template>
            </el-table-column>

            <el-table-column label="执行" prop="pre_executor" width="100" align="center"></el-table-column>
            <el-table-column label="销售" prop="sale" width="100" align="center"></el-table-column>
            <el-table-column label="客户性质" prop="customer_nature" header-align="center" align="center"/>
            <el-table-column label="品牌" prop="brand" width="100" align="center"></el-table-column>
            <!--            <el-table-column label="品牌集团" prop="combine_brand_name" width="100" align="center"></el-table-column>-->
            <el-table-column label="行业" prop="trade" width="100" align="center"></el-table-column>
            <el-table-column label="产地" prop="place_of_origin" width="100" align="center"></el-table-column>
            <!--            品牌集团  行业-->
            <el-table-column label="产品/内容" width="100" prop="product" header-align="center"
                             align="center"></el-table-column>
            <el-table-column label="订单来源" prop="order_source" width="100" align="center"></el-table-column>
            <el-table-column label="客单" prop="price_range" width="100" align="center"></el-table-column>
            <!--            客单-->
            <el-table-column label="品类" prop="product_category" header-align="center"
                             align="center"></el-table-column>
            <el-table-column label="合作形式" prop="cooperate_mode" header-align="center"
                             align="center"></el-table-column>
            <el-table-column label="执行公司" prop="exec_customer_name" width="200" header-align="center"
                             align="center"></el-table-column>
            <!--合作形式 -->
            <el-table-column label="折扣" prop="rebate" width="110" header-align="center"
                             align="center"></el-table-column>
            <el-table-column label="备注" prop="remark" width="120" align="center"/>
            <el-table-column label="创建时间" prop="created_at" width="140" align="center">
              <template slot-scope="{row}">
                <span :title="row.updated_at">{{ row.created_at }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <el-row :gutter="15">
              <el-col :span="24" style="text-align: right">
                <pagination :total.sync="total" :limit.sync="pageData.per_page" :page.sync="pageData.page"
                            @pagination="getList"/>
              </el-col>
            </el-row>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {exportWcm} from "@/api/adOrder";
// import SearchForm from "./components/SearchForm";
import SearchForm from "@/views/adOrder/order/components/SearchForm.vue";
import ChildOrderTable from "./components/ChildOrderTable";
// import MergeOrder from "./components/MergeOrder";
import AdOptColumn from "@/views/adOrder/regular/components/AdOptColumn";
// import ToOrderDetail from "../components/ToDetail";
import ExportBtn from "@/components/export/ExportBtn.vue";
import {getPukeList} from "@/api/regulars";

const MapSearchConfigs = ['sale_id', 'customer_id', 'created_at', 'order_no', 'customer_nature'];
/**
 * 全案营销项目列表（主订单包含子订单）
 */
export default {
  name: "AdWcm",
  components: {
    ExportBtn,
    // MergeOrder,
    SearchForm,
    ChildOrderTable,
    AdOptColumn,
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  props: {
    cooperation: {
      type: String,
      default() {
        return null
      }
    },
    pt: Number, // 操作类型；1：普通订单，2：全案营销，3：普客打包，4：年框大全案，5：纯直播
  },
  data() {
    return {
      MapSearchConfigs,
      loading: false,
      key: new Date().getTime,
      // 选中数组
      ids: [],
      orderBy: '`id` desc',
      // 非单个禁用
      single: true,
      // 非多个禁用
      dataList: [],
      pageData: {page: 1, per_page: 15},
      total: 0,
      offset: 0,
      searchCondition: {
        time_type: 'created_at',
        timeRange: [],
        order_nos: '',
        sale_id: [],
        company_id: null
      },
      expandKeys: [],
      isPreExecutor: 1,
    }
  },
  created() {
    this.$nextTick(() => {
      this.getList()
    })
  },
  methods: {
    handleAdd(type = 'create') {
      let pushItem = {}
      if (type === 'discount') {
        pushItem = {
          name: `orderDiscount`,
        }
      } else {
        pushItem = {
          name: 'createAdOrderRegulars',
          query: {type: "add", isPreExecutor: this.isPreExecutor, fromType: 'puke', cooperation: this.cooperation, pt: this.pt}
        }
      }
      const {href} = this.$router.resolve(pushItem);
      window.open(href, "_blank");
    },
    async handleExport(refName) {
      try {
        const searchCondition = this.$refs.search.handleSearchCondition()
        Object.assign(searchCondition, {orderBy: this.orderBy})
        let name = '营销订单'

        const response = await exportWcm(searchCondition).then(response => {
          return response
        })

        this.$refs[refName].exportSaveXlsx(response, name)

      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }
    },
    afterDeal() {
      this.getList()
    },
    goDetail(row) {
      //详情页面，修改页面
      this.editPage(row.id)
    },
    editPage(id) {
      const {href} = this.$router.resolve({
        name: 'editAdOrderRegulars',
        params: {id: id},
        query: {isPreExecutor: this.isPreExecutor, pt: this.pt}
      });
      window.open(href, "_blank");
    },
    // 操作项
    handleCommand(command, row) {
      switch (command) {
        case 'child': {
          const {href} = this.$router.resolve({
            name: `createAdOrder`,
            query: {type: "child", source_id: row.id, from: 'puke', isPreExecutor: this.isPreExecutor, pt: this.pt}
          });
          window.open(href, "_blank");
          break;
        }
        default: {
          // 默认;
          break;
        }
      }
    },

    //列表查询
    onSubmit() {
      this.pageData.page = 1
      this.getList()
    },
    async getList() {
      this.loading = true
      if (!this.$refs.search) {
        return;
      }

      const searchCondition = this.$refs.search.handleSearchCondition()
      let reqParams = {...searchCondition, ...this.pageData}
      let {data, total, current_page, per_page} = await getPukeList(reqParams).then(res => {
        return res.model
      })
      this.key = new Date().getTime();
      this.loading = false
      this.dataList = data
      this.total = total
      this.pageData.page = Number(current_page)
      this.pageData.per_page = per_page
      this.offset = (current_page - 1) * per_page;
    },
    async goOrderDetail(row) {
      const {href} = this.$router.resolve({
        name: 'editAdOrderRegulars',
        params: {id: row.id},
        query: {isPreExecutor: this.isPreExecutor, pt: this.pt}
      });
      window.open(href, "_blank");
    }
  }
}
</script>

<style lang="scss">
.wcm-order-container {
  .handle-row {
    .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .funcbars-button {
    padding: 6px 8px !important;
    color: rgb(254, 45, 84);
    font-size: 12px;
    border: 1px solid rgb(254, 45, 84);
    cursor: pointer;
    flex: 1;
    border-radius: 3px;
  }
}
</style>
